import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import estilos from './ToolBarPaginas.module.css'

const PaginacionAtencionAClientesComponent = (props) => {
    const {paginas, nombreParaPaginas, paginaActiva, cambiarPagina} = props
    
    const [stickyClass, setStickyClass] = useState('');

    useEffect(() => {
        window.addEventListener('scroll', stickNavbar);
        return () => window.removeEventListener('scroll', stickNavbar);
    }, []);

    const stickNavbar = () => {
        if (window !== undefined) {
            let windowHeight = window.scrollY;
            windowHeight > 150 ? setStickyClass(estilos.sticky_nav) : setStickyClass('');
        }
    };

    const setPagina = (target) => {
        cambiarPagina(Number(target.id))
    } 
    return (
        <Fragment>
            <div className='container'>
                <nav className={`navbar-nav ${stickyClass}`}>
                    <div className={`row mb-2 mt-2`}>
                        <div className="col-md-12" role="group" aria-label="Paginas">
                            {
                                paginas.map((pag) => (
                                    paginaActiva === pag ? (
                                        <button id={pag} key={pag} type="button"
                                             onClick={e => setPagina(e.target)}
                                            style={{ backgroundColor: '#c88b3e', color: 'white' }}
                                            className="btn btn-outline active" >{nombreParaPaginas !== undefined ? nombreParaPaginas[pag - 1] : pag}
                                        </button>
                                    ) : (
                                        <button id={pag} key={pag} type="button"
                                            onClick={e => setPagina(e.target)}
                                            style={{ color: '#c88b3e' }} className="btn btn-outline" >{nombreParaPaginas !== undefined ? nombreParaPaginas[pag - 1] : pag}</button>
                                    )
                                ))
                            }
                        </div>
                    </div>
                </nav>
            </div>
        </Fragment>
    )
};

export default withRouter(PaginacionAtencionAClientesComponent)
